/* eslint @typescript-eslint/no-explicit-any: 'off' */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "./index";
import { UserData } from "../sharedTypes/auth-types";

type AuthState = {
  user: UserData;
  tokenExpiryTime: number;
};

const initialState: AuthState = {
  user: {
    email: "",
    access_token: "",
    refresh_token: "",
  },
  tokenExpiryTime: -1,
};
const authStateSlice = createSlice({
  name: "authentication",
  initialState: initialState,
  reducers: {
    setAuthenticatedUserSession(
      state,
      { payload: { user, tokenExpiryTime } }: PayloadAction<AuthState>
    ) {
      state.user = user;
      state.tokenExpiryTime = tokenExpiryTime;
    },

    clearAuthenticatedUserSession(state) {
      state.user = initialState.user;
      state.tokenExpiryTime = initialState.tokenExpiryTime;
    },
  },
});

export const { setAuthenticatedUserSession, clearAuthenticatedUserSession } =
  authStateSlice.actions;
export const selectCurrentUser = (state: RootState) => state.authentication.user;
export const selectToken = (state: RootState) => state.authentication.user.access_token;
export const selectSessionExpiryTime = (state: RootState) => state.authentication.tokenExpiryTime;
export const authStateSliceReducer = authStateSlice.reducer;
